export default __webpack_public_path__ + "static/media/halas9.6b5abde1.jpg";